import React from "react"

import "./input.scss"

export default ({
  value,
  placeholder,
  onChange,
  onKeyDown,
  type,
  maxLenght,
}) => {
  return (
    <div className="input">
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        maxLength={maxLenght}
      />
    </div>
  )
}
